import React from 'react';

const BRAND_ICON = 'https://customer-assets-rejwkqb3.emergentagent.net/job_cf4b6ddd-cd8a-43a0-80c0-50a20361cba4/artifacts/32a912r7_icono%20neuralia369.jpeg';

const NeuraliaLogo = ({ size = 44, className = '' }) => {
  return (
    <div
      className={`relative rounded-[18px] overflow-hidden border border-white/10 bg-slate-950/80 shadow-[0_0_0_1px_rgba(255,255,255,0.04),0_18px_38px_rgba(59,130,246,0.18)] ${className}`}
      style={{ width: size, height: size }}
      data-testid="neuralia-logo-image-shell"
    >
      <div className="absolute inset-0 rounded-[18px] bg-[radial-gradient(circle_at_50%_50%,rgba(96,165,250,0.25),transparent_58%)] pointer-events-none" />
      <img
        src={BRAND_ICON}
        alt="Icono Neuralia369"
        className="w-full h-full object-cover scale-[1.08] saturate-[1.15] contrast-[1.04]"
        data-testid="neuralia-logo-image"
      />
      <div className="absolute inset-0 rounded-[18px] ring-1 ring-inset ring-white/12 pointer-events-none" />
    </div>
  );
};

export default NeuraliaLogo;